import React, { useContext } from 'react';
import { AppContext } from '../App';
import teamImage from "../assets/banner2.png"

export default function AboutOverview() {
    const appContext = useContext(AppContext);

    return (
        <div className="ycsc-overview-page">
            {/* HERO SECTION / HEADER */}
            {/* <section className="overview-hero py-5 text-center text-md-start">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-12 col-md-8">
                            <span className="badge-sub-title text-uppercase tracking-wider fw-bold"></span>
                            <h1 className="display-4 fw-bold overview-main-title mt-2 mb-3">
                                
                            </h1>
                            <p className="lead overview-hero-lead">
                                
                            </p>
                        </div>
                    </div>
                </div>
            </section> */}

            {/* CORE STATEMENT & HISTORY BRIEF */}
            <section className="py-5 bg-white">
                <div className="container">
                    <div className="row g-4 align-items-center">
                        <div className="col-12 col-lg-6">
                            <h2 className="section-title fw-bold mb-4">Sisi ni Akina Nani?</h2>
                            <p className="text-muted-custom font-light mb-3">
                                YCSC SACCOS Limited ilianza safari yake kama klabu ya kijamii (Social Club) mnamo mwaka 2015 kwa lengo la kuunganisha nguvu na kusaidiana. Kutokana na ukuaji na uhitaji wa kiuchumi, mnamo mwaka 2021 ilirasimishwa rasmi na kuwa Ushirika wa Akiba na Mikopo (SACCOS).
                            </p>
                            <p className="text-muted-custom">
                                Kupitia misingi ya "Mshikamano Daima", tunajenga taasisi imara inayomwezesha kila mwanachama kufikia malengo yake ya kimaendeleo kwa kutoa huduma endelevu za kifedha.
                            </p>
                        </div>
                        {/* WANACHAMA STATS CARD */}
                        <div className="col-12 col-lg-5 offset-lg-1">
                            <div className="stat-card p-5 text-center shadow-sm border-0">
                                <span className="stat-number d-block fw-extrabold text-primary-brand">68</span>
                                <h4 className="fw-bold my-2 text-dark-brand">Wanachama Wote</h4>
                                <p className="small text-muted-custom mb-0">
                                    Tunaendelea kukua kwa pamoja tukiwa na muundo wa kidijitali na picha za wanachama wetu wote zinazodhihirisha uwazi na udugu wetu.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* DIRA, DHAMIRA & MALENGO SECTION */}
            <section className="py-5 bg-light-custom">
                <div className="container">
                    <div className="row g-4">
                        {/* DHAMIRA */}
                        <div className="col-12 col-md-6 col-lg-4">
                            <div className="vision-mission-card p-4 h-100 bg-white shadow-sm">
                                <div className="card-icon-holder mb-3">🎯</div>
                                <h3 className="h5 fw-bold card-title-brand">Dhamira Yetu</h3>
                                <p className="text-muted-custom small mb-0">
                                    Kutoa huduma bora na endelevu za akiba na mikopo kwa wanachama wetu, kwa kutumia teknolojia ya kisasa na kuzingatia misingi ya ushirika ili kukuza ustawi wao wa kiuchumi.
                                </p>
                            </div>
                        </div>
                        {/* DIRA */}
                        <div className="col-12 col-md-6 col-lg-4">
                            <div className="vision-mission-card p-4 h-100 bg-white shadow-sm">
                                <div className="card-icon-holder mb-3">👁️</div>
                                <h3 className="h5 fw-bold card-title-brand">Dira Yetu</h3>
                                <p className="text-muted-custom small mb-0">
                                    Kuwa SACCOS ya mfano na ya kidijitali inayoongoza kwa kuleta mapinduzi ya kiuchumi na kutoa fursa sawa za kimaendeleo kwa wanachama nchini kote.
                                </p>
                            </div>
                        </div>
                        {/* LENGO KUU */}
                        <div className="col-12 col-md-12 col-lg-4">
                            <div className="vision-mission-card p-4 h-100 bg-white shadow-sm">
                                <div className="card-icon-holder mb-3">💎</div>
                                <h3 className="h5 fw-bold card-title-brand">Lengo Kuu</h3>
                                <p className="text-muted-custom small mb-0">
                                    Kuinua hali ya kiuchumi na kijamii ya wanachama kwa kuwasaidia kujenga utamaduni wa kuweka akiba na kuwapatia mikopo yenye masharti nafuu na yenye tija kwa maendeleo yao.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* LEADERSHIP OVERVIEW PREVIEW SECTION */}
            <section className="py-5 bg-white text-center text-lg-start">
                <div className="container">
                    <div className="row align-items-center g-4">
                        <div className="col-12 col-lg-7">
                            <span className="badge-sub-title text-uppercase tracking-wider fw-bold">Uongozi na Utawala</span>
                            <h2 className="section-title fw-bold mt-2 mb-3">Muundo Imara wa Usimamizi</h2>
                            <p className="text-muted-custom mb-0">
                                YCSC SACCOS inaongozwa na viongozi mahiri, wajumbe wa bodi wenye weledi wa hali ya juu, pamoja na kamati ya usimamizi na watendaji makini wanaohakikisha rasilimali za wanachama zinalindwa na kukua kila siku kwa kuzingatia muundo bora wa utawala.
                            </p>
                        </div>
                        <div className="col-12 col-lg-5 text-center text-lg-end">
                            {/* BUTTON THAT NAVIGATES TO THE LEADERSHIP PAGE */}
                            <button 
                                className="btn btn-prestige-action px-4 py-3 fw-bold shadow-sm"
                                onClick={() => appContext.navTo({ item: "leadership" })}
                            >
                                Angalia Viongozi & Watendaji wetu ➔
                            </button>
                        </div>
                    </div>
                </div>
            </section>
			<section className=" aboutImage bg-white text-center text-lg-start mt-4">
					<img src={teamImage} alt='Team' />
			</section>
        </div>
    );
}